import * as React from 'react';

import WordingPC from '../../../../../images/escape_to_school_ef_link/wording-pc.svg';
import WordingSP from '../../../../../images/escape_to_school_ef_link/wording-sp.svg';

const rootElement = document.getElementById('root')!;
const enterMembershipCodeUrl: string = rootElement.getAttribute(
  'data-enter-membership-code-url',
)!;

const isPersonalRegistrationInitiationPath = (path: string): boolean =>
  '/registration/accounts/new' === path;

const showEscapeToSchoolEfLink = (): boolean =>
  isPersonalRegistrationInitiationPath(window.location.pathname);

const EscapeToSchoolEfLink: React.FC = () => (
  <>
    {showEscapeToSchoolEfLink() && (
      <a href={enterMembershipCodeUrl}>
        <div className="escape-to-school-ef-link">
          <img src={WordingPC} className="hidden-xs-down" />
          <img src={WordingSP} className="wording-sp hidden-sm-up" />
        </div>
      </a>
    )}
  </>
);

export default EscapeToSchoolEfLink;
